export default "__VITE_ASSET__BmINpAWn__"